import React, { useEffect } from 'react';
import analyticsService, { AmplitudeEventData, AnalyticsEvent } from 'services/AnalyticsService';
import { MuiBox, MuiTypography } from 'theme/material-ui';
import { connect } from 'react-redux';
import { InterMountainSVG } from 'components/common/AppHeader/AppHeader';
import { FlexBoxRow } from 'components/UI/Layout/FlexBox';
import { Color } from 'modules/styles/colors';
import { EVENT_LINK_EXPIRED, MY_HEALTH_PLUS_DOWNLOAD_SPLASH } from '../constants';
import { FontSize } from 'modules/styles/variables';
import Spacer from 'components/UI/Layout/Spacer';
import Button from 'components/UI/Button/Button';
import { Svg } from 'components/UI/Svg';
import { useHistory } from 'react-router-dom';
import { AuthLiteHeader } from 'components/AuthLite';
import {
  currentLocationPathNameSelector,
  previousLocationPathNameSelector
} from 'store/router/selectors';
import { RootState } from 'store/types';

interface Props {
  currentUrl: string;
  referringUrl: string;
}

export function EventLinkExpired({ currentUrl, referringUrl }: Props) {
  const history = useHistory();

  useEffect(() => {
    const evnentData: AmplitudeEventData = {
      currentUrl,
      referringUrl,
      action: 'COVID-19 light authentication error',
      errorCode: 'N/A',
      errorMessage: 'COVID-19 light authentication error: expired 72-hour authentication'
    };
    analyticsService.logEvent(AnalyticsEvent.ErrorTracking, evnentData);
  }, []);

  const onMhButtonPress = () => {
    const evnentData: AmplitudeEventData = {
      currentUrl,
      referringUrl,
      /* eslint-disable @typescript-eslint/camelcase */
      promotion_type: 'COVID-19 light authentication: expired link'
    };
    analyticsService.logEvent(AnalyticsEvent.PromotionLink, evnentData);

    window.open(MY_HEALTH_PLUS_DOWNLOAD_SPLASH);
  };

  return (
    <MuiBox data-testid="event-link-expired">
      <AuthLiteHeader />
      <MuiBox m={3}>
        <MuiTypography variant="h4">{EVENT_LINK_EXPIRED.title}</MuiTypography>
        <Spacer size="small" />
        <MuiTypography fontSize={FontSize.large}>{EVENT_LINK_EXPIRED.content}</MuiTypography>
      </MuiBox>
      <FlexBoxRow justifyContent="center">
        <MuiBox width="300px">
          <Button
            variant="web-primary"
            onPress={onMhButtonPress}
            testID="event-link-expired-mhp-button"
          >
            <MuiBox display="inline-block" paddingBottom="10px">
              {EVENT_LINK_EXPIRED.buttonText}
            </MuiBox>
            <MuiBox display="inline-block" top="5px">
              <Svg
                name="HeaderMyHealthPlus"
                accessibilityLabel="MyHealth+ logo"
                width={100}
                color="#fff"
              />
            </MuiBox>
          </Button>
        </MuiBox>
      </FlexBoxRow>
    </MuiBox>
  );
}

const mapStateToProps = (state: RootState) => ({
  currentUrl: currentLocationPathNameSelector(state),
  referringUrl: previousLocationPathNameSelector(state)
});

export default connect(mapStateToProps)(EventLinkExpired);
